var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditBgPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "#1790FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.78 14.045L24.5508 13.2743C25.1915 12.6337 25.1915 11.5912 24.5508 10.9504L22.0496 8.44922C21.4089 7.80859 20.3665 7.80859 19.7258 8.44922L18.9551 9.21997L23.78 14.045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2422 17.9324L18.2918 9.88281L23.1167 14.7078L15.0671 22.7573L10.2422 17.9324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73492 18.751L9.05742 22.259C8.96685 22.7282 9.11443 23.2098 9.45232 23.5477C9.72466 23.8201 10.0904 23.9688 10.4678 23.9688C10.5585 23.9688 10.65 23.9602 10.741 23.9425L14.249 23.2651L9.73492 18.751Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(9 8)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBgPrimary);
export default __webpack_public_path__ + "static/media/editBGPrimary.b16e5cd6.svg";
export { ForwardRef as ReactComponent };